<div class="title" [innerHTML]="'twoFactorDialog_Data1' | i18n"></div>
<div class="subtitle" [innerHTML]="'twoFactorDialog_Data2' | i18n"></div>
<div class="buttons-container">
  <button class="btn cancel-btn" (click)="closeDialog()" [innerHTML]="'twoFactorDialog_Data3' | i18n"></button>
  <button class="btn accept-btn" (click)="closeDialog(responses.ACTIVATE)" [innerHTML]="'twoFactorDialog_Data4' | i18n"></button>
</div>
<div class="hint" [innerHTML]="'twoFactorDialog_Data5' | i18n"></div>
